import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RoleGuard } from './core/modules/auth/guards/role.guard';
import { CustomerLoginModule } from './modules/customer-login/customer-login.module';

const routes: Routes = [
  { 
    path: 'sync/login', 
    loadChildren: () => CustomerLoginModule
  },
  {
    path: 'sync',
    canActivate: [ RoleGuard ],
    data: { permission: 'admin' },
    loadChildren: () => import('./layouts/internal/internal.module').then((m) => m.InternalModule)
  },
  {
    path: 'teacher-review',
    loadChildren: () => import('./layouts/teacher-review-layout/teacher-review-layout.module').then((m) => m.TeacherReviewLayoutModule)
  },
  {
    path: 'sso',
    loadChildren: () => import('./layouts/external/external.module').then((m) => m.ExternalModule)
  },
  {
    path: '',
    loadChildren: () => import('./layouts/external/external.module').then((m) => m.ExternalModule)
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
